export const COOKIE_CONSENT_KEY = 'fynapp-cookie-consent';
export const COOKIE_CONSENT_VERSION = 1;

export const DEFAULT_CONSENT = {
    version: COOKIE_CONSENT_VERSION,
    timestamp: null,
    essential: true,
    analytics: false,
    marketing: false,
    doNotSell: false,
    source: null,
};

const isValidConsent = (value) => {
    if (!value || typeof value !== 'object') return false;
    return value.version === COOKIE_CONSENT_VERSION
        && typeof value.essential === 'boolean'
        && typeof value.analytics === 'boolean'
        && typeof value.marketing === 'boolean'
        && typeof value.doNotSell === 'boolean';
};

export const hasGpcSignal = () => (
    typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true
);

export const getStoredConsent = () => {
    try {
        const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return isValidConsent(parsed) ? parsed : null;
    } catch {
        return null;
    }
};

export const saveConsent = (consent) => {
    const payload = {
        ...DEFAULT_CONSENT,
        ...consent,
        version: COOKIE_CONSENT_VERSION,
        timestamp: new Date().toISOString(),
        essential: true,
    };
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(payload));
    return payload;
};

export const getGpcDefaultConsent = () => ({
    ...DEFAULT_CONSENT,
    analytics: false,
    marketing: false,
    doNotSell: true,
    source: 'gpc',
});

export const applyConsent = (consent) => {
    if (!consent) return;

    if (consent.analytics && !consent.doNotSell) {
        // Load analytics scripts here when configured (e.g. Google Analytics).
    }

    if (consent.marketing && !consent.doNotSell) {
        // Load marketing scripts here when configured (e.g. ad pixels).
    }
};
